import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils/ui";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        green:
          "bg-transparent text-emerald-600 hover:bg-secondary [.dark_&]:bg-secondary [.dark_&]:text-emerald-400 [.dark_&]:hover:bg-white/10",
        red: "bg-transparent text-rose-600 hover:bg-secondary [.dark_&]:bg-secondary [.dark_&]:text-rose-400 [.dark_&]:hover:bg-white/10",
        yellow:
          "bg-transparent text-yellow-600 hover:bg-secondary [.dark_&]:bg-secondary [.dark_&]:text-yellow-400 [.dark_&]:hover:bg-white/10",
        amber: "border-amber-600 bg-amber-600 text-amber-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
